import { createStyles, Theme } from '@material-ui/core';

const useStyles = ({ palette, colors }: Theme) => createStyles({
  root: {
    margin: 0,
    maxWidth: '100%',
    WebkitBoxFlex: 1,
    MsFlex: '1 0 auto',
    flex: '1 0 auto',
    outline: 0,
    WebkitTapHighlightColor: 'rgba(255, 255, 255, 0)',
    textAlign: 'left',
    lineHeight: '1.22em',
    padding: '0.4em 0.5em',
    background: '#fff',
    color: 'rgba(0, 0, 0, 0.87)',
    WebkitTransition: 'box-shadow 0.1s ease, border-color 0.1s ease',
    transition: 'box-shadow 0.1s ease, border-color 0.1s ease',
    fontSize: 14,
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    alignContent: 'flex-start',
    '& span[data-placeholder]': {
      display: 'none',
      position: 'absolute',
      left: '0.5em',
      top: '0.4em',
      padding: '0.4em',
      lineHeight: '1.22em',
    },
    '& [data-tag]': {
      verticalAlign: 'baseline',
      margin: '0.14em',
      backgroundColor: '#f3f3f3',
      backgroundImage: 'none',
      border: `1px solid ${colors.border}`,
      padding: '0.58em 0.83em',
      color: palette.text.primary,
      textTransform: 'none',
      borderRadius: '0.29rem',
      WebkitTransition: 'background 0.1s ease',
      OTransition: 'background 0.1s ease',
      transition: 'background 0.1s ease',
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      maxWidth: '100%',
    },
    '& [data-tag] [data-tag-item]': {
      maxWidth: '100%',
      overflow: 'hidden',
    },
    '& [data-tag]:first-child': {
      marginLeft: 0,
    },
    '& [data-tag] [data-tag-handle]': {
      marginLeft: '0.83em',
      cursor: 'pointer',
    },
  },

  focused: {
    position: 'relative',
    borderColor: '#85b7d9',
    background: '#fff',
    color: palette.text.secondary,
    '&:after': {
      transform: 'scaleX(1)',
    },
    '& span[data-placeholder]': {
      display: 'none',
    },
  },

  empty: {
    '& span[data-placeholder]': {
      display: 'inline',
      color: '#ccc',
    },
  },

  labelRoot: {
    fontSize: 12,
  },

  input: {},
  disabled: {
    color: palette.disabledInput.color,
  },
  inputUnderline: {
    '&:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&&:hover:before': {
      borderBottomColor: palette.input.borderBottomColor,
    },
    '&:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&inputFocused:after': {
      borderBottomColor: palette.menuAction.selected,
    },
    '&$disabled:before': {
      borderBottomStyle: 'dashed',
    },
  },
  inputFocused: {},
});

export default useStyles;
